import script from "./kalio-social-media-icons.vue?vue&type=script&setup=true&lang=ts"
export * from "./kalio-social-media-icons.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__